import { useEffect, useRef, useState } from "react";
import api, { mediaSrc } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { X, Upload, Image as ImageIcon, Play } from "lucide-react";
import { useMediaBlob } from "../../lib/useMediaBlob";

function Thumb({ id, onRemove }) {
  const url = useMediaBlob(id);
  const isVideo = url && url.includes("video");
  return (
    <div className="relative group rounded-lg overflow-hidden border border-slate-200 bg-slate-100 aspect-square">
      {url ? (
        isVideo ? (
          <div className="w-full h-full grid place-items-center bg-slate-900 text-white">
            <Play size={24} />
          </div>
        ) : (
          <img src={url} alt="" className="w-full h-full object-cover" />
        )
      ) : (
        <div className="w-full h-full grid place-items-center text-slate-400">
          <ImageIcon size={20} />
        </div>
      )}
      {onRemove && (
        <button
          type="button"
          onClick={() => onRemove(id)}
          className="absolute top-1 right-1 h-6 w-6 rounded-full bg-white/95 border border-slate-200 grid place-items-center opacity-90 hover:opacity-100"
          data-testid={`remove-media-${id}`}
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}

/** Uploads files and returns array of file_ids via onChange */
export default function MediaUploader({ value = [], onChange, testid = "media-uploader" }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const handleFiles = async (files) => {
    if (!files || !files.length) return;
    setBusy(true);
    const uploaded = [];
    for (const f of files) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data.id);
      } catch (e) {
        toast.error(`Yüklenemedi: ${f.name}`);
      }
    }
    if (uploaded.length) {
      onChange([...(value || []), ...uploaded]);
      toast.success(`${uploaded.length} dosya yüklendi`);
    }
    setBusy(false);
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*,video/*"
        multiple
        className="hidden"
        onChange={(e) => handleFiles(Array.from(e.target.files || []))}
        data-testid={`${testid}-input`}
      />
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2">
        {(value || []).map((id) => (
          <Thumb key={id} id={id} onRemove={(rid) => onChange(value.filter((x) => x !== rid))} />
        ))}
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="aspect-square rounded-lg border-2 border-dashed border-slate-300 text-slate-500 hover:border-[#1B4D3E] hover:text-[#1B4D3E] grid place-items-center transition-colors bg-slate-50"
          data-testid={`${testid}-add`}
          disabled={busy}
        >
          {busy ? (
            <span className="text-xs">Yükleniyor…</span>
          ) : (
            <div className="flex flex-col items-center gap-1">
              <Upload size={18} />
              <span className="text-[11px] font-medium">Ekle</span>
            </div>
          )}
        </button>
      </div>
    </div>
  );
}

export { Thumb };
